import { render, staticRenderFns } from "./ErstelleLand.vue?vue&type=template&id=57438a13&"
import script from "./ErstelleLand.vue?vue&type=script&lang=js&"
export * from "./ErstelleLand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports